import React from "react";
import styled, { css } from "styled-components";

const FigureElement = styled.figure`
  margin-bottom: 0;
  border-radius: var(--radius-card);
  border-radius: 24px;
  overflow: hidden;
  width: 100%;
  background: #eee;

  img {
    width: 100%;
    height: auto;
    border: 0.8rem solid var(--dark-grey-palette);
    overflow: hidden;
    border-radius: 22px;
  }

  ${(props) =>
    props.$hasCaption &&
    css`
      img {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }
    `} 

  ${(props) =>
    props.size === "small" &&
    css`
      width: 40%;
    `}

  ${(props) =>
    props.dark &&
    css`
      background: #2b2b2b;
    `}

  ${(props) =>
    props.align === "left" &&
    css`
      width: 50%;
      margin-right: var(--spacing-medium);
      float: left;
    `}

  ${(props) =>
    props.align === "right" &&
    css`
      width: 50%;
      margin-left: var(--spacing-medium);
      float: right;
    `}

  ${(props) =>
    props.spacing === "clear" &&
    css`
      @media (min-width: 500px) {
        margin-bottom: var(--spacing-clear);
      }
    `}

  ${(props) =>
    props.spacing === "medium" &&
    css`
      margin-bottom: var(--spacing-medium);
    `}

  ${(props) =>
    props.spacing === "large" &&
    css`
      margin-bottom: var(--spacing-large);
    `}
`;

const FigureCaptionElement = styled.figcaption`
  color: var(--text-body-color);
  padding: var(--spacing-medium);
  padding-top: calc(var(--spacing-medium) - 0.8rem);
  text-align: center;
  font-size: var(--font-size-text-small);

  ${(props) =>
    props.dark &&
    css`
      background: var(--dark-grey-palette);
      color: var(--white-palette);
    `}
`;

const Image = ({ children, align, size, dark, caption, src, alt, className, spacing }) => {
  return (
    <FigureElement
      $hasCaption={!!caption}
      align={align}
      dark={dark}
      size={size}
      className={className}
      spacing={spacing}
    >
      {children}
      <img src={src} alt={alt} />
      {caption && <FigureCaptionElement dark={dark}>{caption}</FigureCaptionElement>}
    </FigureElement>
  );
};

export default Image;
